import { useQuery } from "@tanstack/react-query";

import { apiSubscription } from "@/services/api-client/subscriptions";

import { subscriptionsKeys } from "./subscriptions.keys";

export const useGetUserSubscriptionQuery = () =>
  useQuery({
    queryKey: subscriptionsKeys.current(),
    queryFn: () => apiSubscription.getUserSubscription(),
  });
